import React from 'react';
import { Spring, animated } from 'react-spring';

import Constraint from './Constraint';
import Title from './Title';
import QuestionIcon from './QuestionIcon';
import Reasons from './Reasons';
import ShieldIcon from './ShieldIcon';
import SafeAndSecure from './SafeAndSecure';

export default () => (
  <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} config={{ delay: 600 }}>
    {animation => (
      <animated.div style={animation}>
        <Constraint>
          <Title>
            <QuestionIcon />
            Why do we need a payment method?
          </Title>

          <Reasons>
            <li>To guarantee payment to the seller.</li>
            <li>Payment hold for the transaction amount will appear in your account.</li>
            <li>
              Charges only confirmed after your item has been delivered.{' '}
              <a
                href="https://help.payondelivery.com/en/articles/2434759-why-does-payondelivery-ask-for-my-payment-cards"
                target="_blank">
                Learn more
              </a>
            </li>
          </Reasons>

          <ShieldIcon />
          <SafeAndSecure>SAFE &amp; SECURE</SafeAndSecure>
        </Constraint>
      </animated.div>
    )}
  </Spring>
);
